<template>
  <div :class="['rereadBox', { inApp: $root.$data.isApp }]">
    <common-title
      :titleName="titleName"
      v-if="!$root.$data.isApp"
      :bcColor="'#F9F9F9'"
      :zIndex="1000"
    ></common-title>
    <div v-if="showReread">
      <div class="rereadNotice">
        <h2>重读申请注意事项</h2>
        <ul>
          <li>1.请同学严格按照申请表格填写相应信息并提交重读申请。</li>
          <li>2.请在协议规定时间内提交重读申请，逾期不提交申请视为自动放弃重读服务。</li>
          <li>3.重读申请提交后，最晚于{{ rereadLastTime }}前按照顺序依次审核并反馈审核结果。</li>
          <li>4.审核通过后开通{{nowYear}}考研课程，仅限于视频观看，如需购买图书或服务请联系班主任。</li>
        </ul>
      </div>
      <div class="rereadCenterBox">
        <h2>申请重读产品<b>*</b></h2>
        <ul class="productBox">
          <li
            v-for="(item, index) in checkList"
            :key="index"
            :class="[
              item.checkItem ? 'checkUi' : '',
              { disableGray: item.status === 3 || item.status === 4 },
            ]"
            @click="checkCourse(item)"
          >
            {{ item.productName }}
          </li>
        </ul>
        <div v-for="(item, index) in contentList" :key="index" class="uploadBox">
          <h2>{{ item.tit }}<b>*</b></h2>
          <span class="subTip">{{ item.subTit }}</span>
          <UploadReread :upLoadType="item.upLoadType" @getListFile="getListFile" />
        </div>
      </div>
      <div class="footSubBox">
        <div @click="rereadSubmit">提交申请</div>
      </div>
    </div>
    <AuditStatus
      v-else
      :auditState="auditState"
      :rejectReason="rejectReason"
      :auditStatusBtn="auditStatusBtn"
      :openProductList="openProductList"
      @againReread="againReread"
      :rereadLastTime="rereadLastTime"
    />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqUserReread, reqAuditReread } from '@/api/personal/myAgreement';
import { setAppointTime, replaceHyphens } from '@/utils/tools';
import UploadReread from './uploadReread.vue';
import AuditStatus from './auditStatus.vue';
// new Date(replaceHyphens(data.futureLiveBroadcastInfoRespVO.startTime)).getTime()
export default {
  components: {
    CommonTitle,
    UploadReread,
    AuditStatus,
  },
  data() {
    return {
      titleName: '重读协议',
      rereadInfo: JSON.parse(sessionStorage.getItem('REREAD')) || null,
      auditState: 0, // 审核状态
      showReread: true,
      upLoadType: 1, // 1准考证2初试成绩3院校
      examCardImgList: [],
      examScoreImgList: [],
      collegeRequirementsImgList: [],
      rereadLastTime: '2023年4月25日', // 结束时间+15天
      contentList: [
        {
          tit: '准考证截图',
          subTit: '请上传准考证照片，照片中需包含完整的准考证',
          upLoadType: 1,
        },
        {
          tit: '初试成绩截图',
          subTit: '请上传您的成绩查询图',
          upLoadType: 2,
        },
        {
          tit: '报考院校报考专业成绩要求截图',
          subTit:
            '请上传所报考院校、专业及该专业国家线分数截图（如报考院校为34所，需提供该院校自主划线的分数线截图）',
          upLoadType: 3,
        },
      ],
      rejectReason: '', // 审核失败原因
      auditStatusBtn: false, // 审核失败-重新申请按钮
      checkList: [], // 勾选课程list
      openProductList: [], // 审核通过后开通的课程list
      nowYear: Number(new Date().getFullYear().toString().slice(2)) + 1,
    };
  },

  computed: {},
  created() {
    const { everRead } = this.rereadInfo || JSON.parse(sessionStorage.getItem('REREAD'));
    this.checkList = this.rereadInfo?.productInfoVOS;
    this.checkList.map((item) => {
      if (item.status === 3 || item.status === 4) {
        Object.assign(item, {
          checkItem: false,
        });
      } else {
        Object.assign(item, {
          checkItem: true,
        });
      }
    });
    if (everRead === 1) {
      this.showReread = false;
      this.titleName = '重读申请';
      this.getAuditDetail();
    }
    this.getLastTime();
  },
  mounted() {
    window.scrollTo(0, 0);
  },

  methods: {
    getLastTime() {
      const { reApplyEndTime } = this.rereadInfo;
      const time = new Date(replaceHyphens(reApplyEndTime));
      this.rereadLastTime = setAppointTime(time, +15).full;
    },
    // 选择重读课程
    checkCourse(data) {
      if (data.status === 3 || data.status === 4) {
        this.$toast('该产品的协议已失效或作废');
        return;
      }
      // eslint-disable-next-line no-unused-expressions
      this.checkList?.map((item) => {
        if (data.productSkuId === item.productSkuId) {
          Object.assign(item, {
            checkItem: !item.checkItem,
          });
        }
      });
      this.$forceUpdate();
    },
    // 上传图片list
    getListFile(type, list) {
      if (type === 1) {
        this.examCardImgList = list;
      } else if (type === 2) {
        this.examScoreImgList = list;
      } else {
        this.collegeRequirementsImgList = list;
      }
    },
    // 提交重读协议
    async rereadSubmit() {
      const applyProductList = [];
      this.checkList.map((item) => {
        if (item.checkItem) {
          applyProductList.push(item);
        }
      });
      if (!applyProductList.length) {
        this.$toast('请选择申请重读产品');
        return;
      }
      if (
        !this.collegeRequirementsImgList.length ||
        !this.examCardImgList.length ||
        !this.examScoreImgList.length
      ) {
        this.$toast('请上传图片');
        return;
      }
      const data = {
        applyProductList,
        agreementId: this.rereadInfo.agreementId,
        collegeRequirementsImgList: this.collegeRequirementsImgList,
        examCardImgList: this.examCardImgList,
        examScoreImgList: this.examScoreImgList,
      };
      const res = await reqUserReread(data);
      if (res?.code === 0) {
        this.showReread = false;
        this.auditState = 0;
        this.titleName = '重读申请';
      } else {
        this.$toast(res?.msg);
      }
    },
    // 查询审核状态
    async getAuditDetail() {
      const { agreementId } = this.rereadInfo;
      const res = await reqAuditReread(agreementId);
      if (res?.code === 0) {
        this.auditState = res?.data.auditStatus;
        if (this.auditState === 2) {
          this.openProductList = res?.data.openProductList;
        }
        // 审核失败
        if (this.auditState === 3) {
          this.rejectReason = res?.data.rejectReason;
          const currentTime = res.currentTime
            ? new Date(replaceHyphens(res.currentTime)).getTime()
            : new Date().getTime();
          const { reApplyEndTime } = this.rereadInfo;
          const endTime = new Date(replaceHyphens(reApplyEndTime));
          // 重读申请状态失败后重新申请按钮展示结束时间
          const endBtnTime = setAppointTime(endTime, +10).mons.getTime();
          if (endTime.getTime() < currentTime < endBtnTime) {
            this.auditStatusBtn = true;
          } else {
            this.auditStatusBtn = true;
          }
        }
      }
    },
    // 重新申请
    againReread() {
      this.showReread = true;
    },
  },
  beforeDestroy() {},
  destroyed() {
    sessionStorage.removeItem('REREAD');
  },
};
</script>

<style lang="scss" scoped>
.rereadBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 170px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 170px;
  }
  .rereadNotice {
    box-sizing: border-box;
    width: 100%;
    padding: 43px 36px;
    background: #fff;
    h2 {
      margin-bottom: 29px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
    }
    ul {
      li {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;
      }
    }
  }
  .rereadCenterBox {
    box-sizing: border-box;
    width: 100%;
    margin-top: 22px;
    padding: 43px 36px;
    background: #fff;
    h2 {
      margin-bottom: 22px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      b {
        color: #ff3938;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
    }
    .productBox {
      .disableGray {
        background: #f5f5f5 !important;
      }
      li {
        box-sizing: border-box;
        width: 605px;
        height: 54px;
        margin-bottom: 14px;
        color: #666;
        font-weight: 400;
        font-size: 22px;
        line-height: 54px;
        text-indent: 24px;
        background: #fff;
        border: 2px solid #e8e8e8;
        border-radius: 4px;
        &.checkUi {
          position: relative;
          color: #ff7f41;
          background: #fff5ed;
          border: 2px solid #ff7f41;
        }
        &.checkUi::before {
          position: absolute;
          right: -1px;
          bottom: -1px;
          width: 29px;
          height: 29px;
          background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/checked.png');
          background-size: 100% 100%;
          content: '';
        }
      }
    }
    .uploadBox {
      margin-top: 72px;
      .subTip {
        display: block;
        margin-bottom: 25px;
        color: #666;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
  .footSubBox {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    padding: 22px 0 65px 0;
    background: #fff;
    box-shadow: 0 -4px 18px 0 rgba(0, 0, 0, 0.07);
    > div {
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 45px;
    }
  }
}
</style>
